import { render } from "./PropertyPriceComponent.vue?vue&type=template&id=e85fdcf8&scoped=true"
import script from "./PropertyPriceComponent.vue?vue&type=script&lang=js"
export * from "./PropertyPriceComponent.vue?vue&type=script&lang=js"

import "./PropertyPriceComponent.vue?vue&type=style&index=0&id=e85fdcf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e85fdcf8"]])

export default __exports__